import { Outlet } from 'react-router-dom';
import { Header } from '@/components/layout/header';
import { DesktopSidebar } from '@/components/layout/desktop-sidebar';
import { BottomNav } from '@/components/layout/bottom-nav';
import { InstallPrompt } from '@/components/layout/install-prompt';
import { GlobalModals } from '@/components/layout/global-modals';
import { useAuditStream } from '@/hooks/use-audit-stream';

export function RootLayout() {
  useAuditStream();

  return (
    <div className="bg-background text-foreground">
      {/* Desktop (lg+): sidebar fixa à esquerda + conteúdo centralizado, sem bottom-nav */}
      <DesktopSidebar />

      {/*
        Mobile (<lg): scroll normal do body (window). A tap bar é position:fixed bottom-0
        (52px + safe-area), cravada na borda inferior REAL da viewport — sem depender de
        100dvh/100vh, que no iOS standalone deixava faixa branca embaixo. O <main> reserva
        o espaço da barra via padding-bottom (altura + safe-area).
        Desktop (lg+): fluxo normal, sidebar fixa, sem tap bar.
      */}
      <div className="min-h-dvh lg:min-h-screen lg:pl-[264px]">
        {/* Mobile (<lg): header sticky no topo. Em lg fica escondido (lg:hidden interno) */}
        <Header />

        <main className="px-5 pt-6 pb-[calc(env(safe-area-inset-bottom)+60px)] lg:mx-auto lg:w-full lg:max-w-3xl lg:px-8 lg:py-8">
          <Outlet />
        </main>

        {/* Mobile (<lg): tap bar fixa na base real da viewport (lg:hidden interno) */}
        <BottomNav />
        <InstallPrompt />
      </div>

      <GlobalModals />
    </div>
  );
}
